<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.company.status === 'active'" size="small" type="success">Aktív</el-tag>
      <el-tag v-if="scope.row.company.status === 'inactive'" size="small" type="warning">Inaktív</el-tag>
      <el-tag v-if="scope.row.company.status === 'forbidden'" size="small" type="danger">Tiltott</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
